import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import reducercomponent from './common-component'
import init from './init'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        reducercomponent,
        init,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
